module.exports = __webpack_public_path__ + "img/ic_logo_transparent.91b9a7bd.png";